// 余额明细类型
export const BALANCE_RECORD_TYPE = {
  ALL: 0,
  INCOME: 1,
  EXPENDITURE: 2,
};

// 余额明细类型对应的key
export const BALANCE_RECORD_TYPE_TO_KEY = {
  [BALANCE_RECORD_TYPE.ALL]: 'all',
  [BALANCE_RECORD_TYPE.INCOME]: 'income',
  [BALANCE_RECORD_TYPE.EXPENDITURE]: 'expenditure',
};

// 余额明细类型tab选项
export const BALANCE_RECORD_TYPE_TABS = [
  {
    title: '全部',
    key: BALANCE_RECORD_TYPE.ALL,
  },
  {
    title: '支出',
    key: BALANCE_RECORD_TYPE.EXPENDITURE,
  },
  {
    title: '收入',
    key: BALANCE_RECORD_TYPE.INCOME,
  },
];

export const PAGE_SIZE = 20;

// 收入明细类型
export const INCOME_DETAILS_TYPE = {
  CASH: 1,
  CLOUD_BEAN: 2,
  DEDUCTION: 3, // 运营扣减
};
